import { ChangeEvent, FC, useCallback, useState } from 'react';
import { Button, Flex, TextField } from '@servicetitan/anvil2';
import SendIcon from '@servicetitan/anvil2/assets/icons/material/round/send.svg';
import { useKeyDown } from '../use-key-down';

import * as Styles from './footer-row.module.less';

interface FooterRowProps {
    onMessageSend?: (message: string) => Promise<void>;
    isLoading: boolean;
    disabled: boolean;
}

export const FooterRow: FC<FooterRowProps> = ({ onMessageSend, isLoading, disabled }) => {
    const [text, setText] = useState('');

    const handleTextChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setText(event.target.value);
    }, []);

    const handleSendClick = useCallback(() => {
        onMessageSend?.(text);
        setText('');
    }, [onMessageSend, text]);

    useKeyDown('Enter', handleSendClick);

    return (
        <Flex className={Styles.footerRow} direction="row" gap="3">
            <TextField
                flexGrow={1}
                placeholder="Type your message"
                value={text}
                onChange={handleTextChange}
                disabled={disabled}
                data-cy="chat-input"
            />
            <Button
                onClick={handleSendClick}
                disabled={!text.length || isLoading || disabled}
                appearance="secondary"
                icon={SendIcon}
                data-cy="chat-send-button"
            />
        </Flex>
    );
};
